import React from 'react'
import { Box, Typography, Link } from '@mui/material'
import { CommonTable } from '../common'

const ConsentNotice = () => {
  // Table 1 columns - for section 1.2
  const columns1 = [
    { id: 'slNo', label: 'Sl. No', width: '80px' },
    {
      id: 'typeOfData',
      label: 'Type of Personal Data Collected',
      width: '300px',
      render: value => (
        <Typography
          component="div"
          sx={{
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            lineHeight: 1.4,
            fontSize: '13px',
          }}
        >
          {value}
        </Typography>
      ),
    },
    {
      id: 'purpose',
      label: 'Purpose of Collection',
      width: '300px',
      render: value => (
        <Typography
          component="div"
          sx={{
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            lineHeight: 1.4,
            fontSize: '13px',
          }}
        >
          {value}
        </Typography>
      ),
    },
  ]

  // Table 1 data - for section 1.2
  const tableData1 = [
    {
      id: 1,
      slNo: '1.',
      typeOfData: 'Name',
      purpose: 'Name, Email and Contact number is for user creation purpose',
    },
    {
      id: 2,
      slNo: '2.',
      typeOfData: 'Email ID',
      purpose: 'Name, Email and Contact number is for user creation purpose',
    },
  ]

  // Table 2 columns - for section 1.4
  const columns2 = [
    { id: 'slNo', label: 'Sl. No', width: '80px' },
    {
      id: 'typeOfData',
      label: 'Type of Personal Data Collected',
      width: '300px',
      render: value => (
        <Typography
          component="div"
          sx={{
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            lineHeight: 1.4,
            fontSize: '13px',
          }}
        >
          {value}
        </Typography>
      ),
    },
    {
      id: 'retention',
      label: 'Period of Retention',
      width: '300px',
      render: value => (
        <Typography
          component="div"
          sx={{
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            lineHeight: 1.4,
            fontSize: '13px',
          }}
        >
          {value}
        </Typography>
      ),
    },
  ]

  // Table 2 data - for section 1.4
  const tableData2 = [
    {
      id: 1,
      slNo: '1.',
      typeOfData: 'Name',
      retention:
        'The standard default Data Retention Period for such automated system/ application logs is one year.',
    },
    {
      id: 2,
      slNo: '2.',
      typeOfData: 'Email ID',
      retention:
        'The standard default Data Retention Period for such automated system/ application logs is one year.',
    },
    {
      id: 3,
      slNo: '3.',
      typeOfData: 'Engagement related data',
      retention:
        'The standard default data retention period for client engagement documents has been set to eight years.',
    },
  ]

  return (
    <Box className="terms-scroll-content" sx={{ p: 2 }}>
      <Box className="consentNotice">
        {/* 1.1 */}
        <Box
          sx={{
            display: 'flex',
            mb: 2,
            alignItems: 'flex-start',
            '.MuiTypography-root': { fontSize: '12px' },
          }}
        >
          <Typography sx={{ minWidth: '40px', fontWeight: 'bold', mr: 2 }}>
            1.1
          </Typography>
          <Typography sx={{ flex: 1, lineHeight: 1.6 }}>
            This consent notice ("Notice") is to inform you of how we,{' '}
            <Typography component="span" sx={{ fontWeight: 'bold' }}>
              PricewaterhouseCoopers Private Limited
            </Typography>
            , want to process your personal data, so that you may give your
            informed consent.
          </Typography>
        </Box>

        {/* 1.2 */}
        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              display: 'flex',
              mb: 2,
              alignItems: 'flex-start',
              '.MuiTypography-root': { fontSize: '12px' },
            }}
          >
            <Typography sx={{ minWidth: '40px', fontWeight: 'bold', mr: 2 }}>
              1.2
            </Typography>
            <Typography sx={{ flex: 1, lineHeight: 1.6 }}>
              We will only collect, hold, store and process, both electronically and physically, as much personal data as is necessary for the purposes mentioned in this Notice. The personal data will not be used for any other purpose except to the extent we need to use it for any other purpose which falls within certain legitimate uses as prescribed under applicable laws including fulfilling any obligation under applicable law. Only the following personal data will be collected from you for the purposes mentioned in this Notice:
            </Typography>
          </Box>

          {/* Table 1 */}
          <Box sx={{ my: 2 }}>
            <CommonTable
              columns={columns1}
              data={tableData1}
              loading={false}
              showActions={false}
            />
          </Box>
        </Box>

        {/* 1.3 */}
        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              display: 'flex',
              mb: 2,
              alignItems: 'flex-start',
              '.MuiTypography-root': { fontSize: '12px' },
            }}
          >
            <Typography sx={{ minWidth: '40px', fontWeight: 'bold', mr: 2 }}>
              1.3
            </Typography>
            <Typography sx={{ flex: 1, lineHeight: 1.6 }}>
              We will process your personal data only till the purposes mentioned are served, as specified below:
            </Typography>
          </Box>
          {/* Table 2 */}
          <Box sx={{ my: 2 }}>
            <CommonTable
              columns={columns2}
              data={tableData2}
              loading={false}
              showActions={false}
            />
          </Box>
        </Box>

        {/* 1.4 */}
        <Box
          sx={{
            display: 'flex',
            mb: 2,
            alignItems: 'flex-start',
            '.MuiTypography-root': { fontSize: '12px' },
          }}
        >
          <Typography sx={{ minWidth: '40px', fontWeight: 'bold', mr: 2 }}>
            1.4
          </Typography>
          <Typography sx={{ flex: 1, lineHeight: 1.6 }}>
            As part of a global network of PricewaterhouseCoopers firms (each of which is a separate legal entity), we exchange or may need to exchange personal data within the network or with other overseas service providers/contractors working and acting on our behalf. As a result, we may transfer personal data outside India to other countries whose privacy laws provide different levels of protection. We may also use overseas facilities to process, host or back up the personal data. As a result, we may need to transfer personal data to our overseas facilities for these purposes. However, any such personal data transferred shall be subject to appropriate data protection obligations and requirements under applicable law. You hereby consent to the transfer, storage and processing by us, our agents, contractors, subcontractors or other PricewaterhouseCoopers firms, of such personal data within or outside India in accordance with the above.
          </Typography>
        </Box>

        {/* 1.5 */}
        <Box
          sx={{
            display: 'flex',
            mb: 2,
            alignItems: 'flex-start',
            '.MuiTypography-root': { fontSize: '12px' },
          }}
        >
          <Typography sx={{ minWidth: '40px', fontWeight: 'bold', mr: 2 }}>
            1.5
          </Typography>
          <Typography sx={{ flex: 1, lineHeight: 1.6 }}>
            You have the right to i) access your personal data information provided by you; ii) correct and update your personal data; iii) erase your personal data; iv) seek redress of any grievance regarding processing of personal data as stated herein; and v) nominate someone to exercise rights in case of death or incapacity.
          </Typography>
        </Box>

        {/* 1.6 */}
        <Box
          sx={{
            display: 'flex',
            mb: 2,
            alignItems: 'flex-start',
            '.MuiTypography-root': { fontSize: '12px' },
          }}
        >
          <Typography sx={{ minWidth: '40px', fontWeight: 'bold', mr: 2 }}>
            1.6
          </Typography>
          <Typography sx={{ flex: 1, lineHeight: 1.6 }}>
            You can withdraw your consent for processing of your personal data at any time, signified by your clear affirmative action by raising your request {' '}
            <Link
              href="https://privacyportal-eu.onetrust.com/webform/f13f2198-97ab-4c25-a5cd-0fca8ada2e21/b4e47c5a-ca49-419b-85de-0e1f7f6457eb"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </Link>
            . In the event you continue to have any grievance in relation to the processing of your personal data or your rights, you may submit your request at{' '}
            <Link href="mailto:in_privacy.in@pwc.com">
              in_privacy.in@pwc.com
            </Link>
          </Typography>
        </Box>

        {/* 1.7 */}
        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              display: 'flex',
              mb: 2,
              alignItems: 'flex-start',
              '.MuiTypography-root': { fontSize: '12px' },
            }}
          >
            <Typography sx={{ minWidth: '40px', fontWeight: 'bold', mr: 2 }}>
              1.7
            </Typography>
            <Typography sx={{ flex: 1, lineHeight: 1.6 }}>
             If you do so, your personal data will be erased, unless there is any legal requirement to retain it.
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              mb: 2,
              alignItems: 'flex-start',
              ml: '56px',
              '.MuiTypography-root': { fontSize: '12px' },
            }}
          >
            <Typography sx={{ flex: 1, lineHeight: 1.6 }}>
              In case you choose to subsequently withdraw your consent, the consequences of such withdrawal shall be borne by you, and such withdrawal shall not affect the legality of processing of the personal data based on your consent prior to such withdrawal.
            </Typography>
          </Box>
        </Box>

        {/* 1.8 */}
        <Box
          sx={{
            display: 'flex',
            mb: 2,
            alignItems: 'flex-start',
            '.MuiTypography-root': { fontSize: '12px' },
          }}
        >
          <Typography sx={{ minWidth: '40px', fontWeight: 'bold', mr: 2 }}>
            1.8
          </Typography>
          <Typography sx={{ flex: 1, lineHeight: 1.6 }}>
            You confirm that that you have not suppressed any material information while providing your personal data. 
          </Typography>
        </Box>

        {/* 1.9 */}
        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              display: 'flex',
              mb: 2,
              alignItems: 'flex-start',
              '.MuiTypography-root': { fontSize: '12px' },
            }}
          >
            <Typography sx={{ minWidth: '40px', fontWeight: 'bold', mr: 2 }}>
              1.9
            </Typography>
            <Typography sx={{ flex: 1, lineHeight: 1.6 }}>
              In case of any questions regarding our processing of your personal data, you may contact us details referenced in 1.7 section.
            </Typography>
          </Box>
            <Box
            sx={{
              display: 'flex',
              mb: 2,
              alignItems: 'flex-start',
              ml: '56px',
              '.MuiTypography-root': { fontSize: '12px' },
            }}
          >
            <Typography sx={{ flex: 1, lineHeight: 1.6 }}>
              You can also register any grievance by mailing at{' '}
               <Link href="mailto:in_privacy.in@pwc.com">
              in_privacy.in@pwc.com
            </Link>.
            </Typography>
          </Box>
        </Box>

        {/* 1.10 */}
        <Box
          sx={{
            display: 'flex',
            mb: 2,
            alignItems: 'flex-start',
            '.MuiTypography-root': { fontSize: '12px' },
          }}
        >
          <Typography sx={{ minWidth: '40px', fontWeight: 'bold', mr: 2 }}>
            1.10
          </Typography>
          <Typography sx={{ flex: 1, lineHeight: 1.6 }}>
            This Notice shall be governed by the laws of India, and the parties hereby submit to the exclusive jurisdiction of the competent courts of New Delhi, India.
          </Typography>
        </Box>

        {/* 1.11 */}
        <Box
          sx={{
            display: 'flex',
            mb: 2,
            alignItems: 'flex-start',
            '.MuiTypography-root': { fontSize: '12px' },
          }}
        >
          <Typography sx={{ minWidth: '40px', fontWeight: 'bold', mr: 2 }}>
            1.11
          </Typography>
          <Typography sx={{ flex: 1, lineHeight: 1.6, fontWeight: 'bold' }}>
            You hereby communicate your free, specific, informed, unconditional and unambiguous consent (in terms of Clauses 1.4, 1.5 and 1.6 below) to our processing of your personal data, for the purposes as specified in Clause 1.3 below, and which consent is signified by your clear affirmative action of  [
            <Typography
              component="span"
              sx={{ color: 'red', fontWeight: 'bold' }}
            >
              signing this Notice
            </Typography>
            ] / [
            <Typography
              component="span"
              sx={{ color: 'red', fontWeight: 'bold' }}
            >
              clicking on the "I accept" button below
            </Typography>
            ].
          </Typography>
        </Box>

        {/* 1.12 */}
        <Box
          sx={{
            display: 'flex',
            mb: 2,
            alignItems: 'flex-start',
            '.MuiTypography-root': { fontSize: '12px' },
          }}
        >
          {/* <Typography sx={{ minWidth: '40px', fontWeight: 'bold', mr: 2 }}>
            1.12
          </Typography>
          <Typography sx={{ flex: 1, lineHeight: 1.6 }}>
            You can save a copy of this notice by &lt;example: clicking here
            [hyperlink]&gt; and download it on to your computer system for
            reference on your mobile.
          </Typography> */}
        </Box>
      </Box>
    </Box>
  )
}

export default ConsentNotice
